import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ToDoListEditor.html?raw';
import "./ToDoListEditorTypes";
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import "../../../moreCore/UI/StaticTable/StaticTable";


interface RowWidget {
    entity: any;
    widgets: Array<any>;
    tableRow: StaticTable.StaticTableRow<any>;
}
class ToDoListEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;

    staticTable: MdsLax<InstanceType<typeof StaticTable>>;
    toDoAppointmentsArrayName: string = "EL_todo_appointments_ev_booking";
    tableContainer: HTMLElement;
    batchSaveButton: HTMLButtonElement;
    unsavedRows: Array<number> = [];
    rowIndex_savingInProcess: number[] = [];
    bookingId: string = null;

    _request: any = null;
    saveDataControllerurl = "AppointmentToDoListEditor/UpdateRowData";
    loadDataControllerurl = "AppointmentToDoListEditor/LoadTodoAppointments";
    _textAreaTimeout: number;
    data: object[] = null;

    widgetRegistry: Array<RowWidget>;

    openToDos_only: boolean = true;

    constructor(data?: object[]) {
        super(...(arguments as unknown as []));
        if (data) {
            this.data = data;
        }
    }

    tableLayout: StaticTable.Layout = {
        "name": "default",
        "label": "Default",
        rows: [{
            attributes: ["ref_ht_todo_description_package.ref_todo_package.description", "c_todo_description", "due_date"],
            colNamesInternal: ["ref_ht_todo_description_package.ref_todo_package.description", "c_todo_description", "due_date"],
            headings: ["ToDo Paket", "Aufgabe", "Erledigen bis"],
            colspans: [1, 2, 1],
            
        },
            {
                attributes: [],
                colspans: [3, 1],
                headings: ["Anmerkung", "Erledigt"],
                colNamesInternal: ["note", "actionFinish"]
            }
        ]
    };

    table_formatterFunction(cell: StaticTable.StaticTableCell<any>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let index = cell.tableRow.lineIndex;
        let value = cell.value;


        switch (colName) {
            case "actionFinish":
                let checkbox = new CheckBox();
                checkbox.setLabel("Erledigt");
                //this.staticTable.addWidgetToRegistry(checkbox, rowIndex, header);
                let is_finished: boolean = this.PitHelper.getEntityAttributeValue(entity, "is_finished", more.PitHelperStructureFormatType.json);
                checkbox.setValue(is_finished);
                this.UiModder.domStyle.set(checkbox.domNode, "justify-content", "flex-end");
                checkbox.placeAt(node);
                checkbox.on("change", lang.hitch(this, "_onChangeCheckBox", cell));
                this.addWidgetToRegistry(checkbox, cell);
                return true;
                break;

            case "note":
                let note: string = this.PitHelper.getEntityAttributeValue(entity, "note", more.PitHelperStructureFormatType.json);
                let textArea = this.UiModder.domConstruct.create("textarea", {
                    "placeholder": "Anmerkung",
                    "name": "note",
                    "rows": 3,
                    "onkeyup": lang.hitch(this, this._onBlurTextarea, cell),
                    "style": "resize: none",
                    "innerHTML": note,
                    "class": "w3-input",
                }, node);
                this.addWidgetToRegistry(textArea, cell);
                return true;
                break;

            default: return false;
        }
    }

    addWidgetToRegistry(widget: any, cell: StaticTable.StaticTableCell<any>): void {
        let regEntry = this.getRegistryEntryByRowIndex(cell.tableRow.rowGroup.rowIndex);

        if (regEntry == null) {
            regEntry = {
                tableRow: cell.tableRow,
                widgets: [],
                entity: cell.entity
            };

            this.widgetRegistry.push(regEntry);
        }

        regEntry.widgets.push(widget);
        
    }

    getRegistryEntryByRowIndex(index: number): RowWidget {
        for (let widget of this.widgetRegistry) {
            if (widget.tableRow.rowGroup.rowIndex == index) {
                return widget;
            }
        }

        return null;
    }

    _onChangeCheckBox(cell: StaticTable.StaticTableCell<any>): void {
        this._setUnsavedValueStyle(cell);
    }
    _onBlurTextarea(cell: StaticTable.StaticTableCell<any>): void {
        this._setUnsavedValueStyle(cell);
    }
    _setUnsavedValueStyle(cell: StaticTable.StaticTableCell<any>): void {
        let rowIndex = cell.tableRow.rowGroup.rowIndex;
        let registry = this.getRegistryEntryByRowIndex(rowIndex);
        let rowWidgets = [];
        if (registry) {
            rowWidgets = registry.widgets;
        }
        
        let rowWidgetValues: object = {};
        //let button: any;

        for (let i = 0; i < rowWidgets.length; i++) {
            let widget = rowWidgets[i]

            // ist es die Textarea, der dieser Name verpasst wurde?
            if (widget["name"] && widget["name"] == "note") { 
                rowWidgetValues[widget["name"]] = widget["value"];
            }
            // oder ist es die Checkbox?
            else if (widget.id.indexOf("CheckBox") != -1) {
                rowWidgetValues["is_finished"] = widget.getValue();
            }
        }

        let data = { entity: cell.entity, rowWidgetValues: rowWidgetValues };

        if (data.rowWidgetValues["is_finished"] != data.entity["is_finished"] || data.rowWidgetValues["note"] != data.entity["note"]) {
            //button.disabled = false;

            if (this.unsavedRows.indexOf(rowIndex) == -1) this.unsavedRows.push(rowIndex);

        } else {
            let i: number = this.unsavedRows.indexOf(rowIndex);
            if (i != -1) this.unsavedRows.splice(i, 1);
        }

        this.setBatchSaveButtonStyle();
    }

    setTaskProgressStyles(): void {

        if (this.openToDos_only == false) {
            this.staticTable.setConditionalStyleClass("is_finished", false, "inProgressColoration");
            this.staticTable.setConditionalStyleClass("is_finished", true, "allDoneColoration");

        } else {
            this.staticTable._removeCustomRowClasses();
        }
    }

    loadData(bookingID: string): void {
        
        this.bookingId = bookingID;
        this.StandbyStart();

        let data: { ID: string, openOnly : boolean} = { ID: bookingID, openOnly: this.openToDos_only };

        if (this._request != null) {
            this._request.cancel();
        }


        this._request = this.RequestManager.post(
            window.appRoot + this.loadDataControllerurl,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, "_onLoadData_Response"),
            lang.hitch(this, function (err) { // errorCallback
                this.StandbyStop();
                if (err && err["Message"] ) {
                    alert("ERROR beim Laden von Daten: " + err["Message"]);
                    console.log(err);
                } 
            })
        );

    }

    _onLoadData_Response(response): void {
        console.log("ToDoListEditor _onLoadData_Response: ", response);
        this.StandbyStop();

        if (response) {
            this.data = response;
            if (this.staticTable == null) {
                this.createTable();
            } else {
                this.staticTable.setData(this.data);
                this.setTaskProgressStyles();
            }
        }
    }

    createTable(): void {

        if (this.staticTable != null) {
            this.staticTable.destroy();
            this.tableContainer.innerHTML = null;
        }

        this.staticTable = new StaticTable();

        //this.UiModder.domStyle.set(this.staticTable.tableRoot, "overflow", "hidden");
        
        this.staticTable.setStickyHeader(true);
        this.staticTable.setHeaderColor("#858585","#ffffff");
        this.staticTable.setFormatter(this.table_formatterFunction);
        this.staticTable.setTableLayout(this.tableLayout);
        this.UiModder.domConstruct.place(this.staticTable.domNode, this.tableContainer);
        if (this.data) this.staticTable.setData(this.data);

        this.staticTable.setCyAttribute("toDoListEditor");

        this.setTaskProgressStyles();
    }

    tableRowButton_click_saveData(): void {

        let data = []

        for (let rowIndex of this.unsavedRows) {
            let rowReg = this.getRegistryEntryByRowIndex(rowIndex);

            let rowEntity = null; 

            let rowWidgets = null;

            if (rowReg) {
                rowWidgets = rowReg.widgets;
                rowEntity = rowReg.entity;
            }
            let rowWidgetValues: object = {};

            for (let i = 0; i < rowWidgets.length; i++) {

                if (rowWidgets[i]["name"] && rowWidgets[i]["name"] == "note") {
                    rowWidgetValues[rowWidgets[i]["name"]] = rowWidgets[i]["value"];
                } else if (rowWidgets[i].id.indexOf("CheckBox") != -1) {
                    rowWidgetValues["is_finished"] = rowWidgets[i].getValue();
                }
            }

            let dataSet = { entity: rowEntity, rowWidgetValues: rowWidgetValues };

            if (dataSet.rowWidgetValues["is_finished"] != dataSet.entity["is_finished"] || dataSet.rowWidgetValues["note"] != dataSet.entity["note"]) {

                this.rowIndex_savingInProcess.push(rowIndex);

                data.push(dataSet);
            } 

        }

        this.saveRowData(data);
        
    }

    saveRowData(data: Array<{ entity: object, rowWidetValues: object }>): void {

        this.StandbyStart();

        if (this._request != null) {
            this._request.cancel();
        }
        this.RequestManager.post(
            window.appRoot + this.saveDataControllerurl,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, "_onSaveRowData_Response"),
            lang.hitch(this, function (err) { // errorCallback
                this.StandbyStop();
                if (err && err["Message"] != "success") {
                    this.rowIndex_savingInProcess = null;
                    alert("ERROR beim UpdateItemChanges: " + err["Message"]);
                    console.log(err);
                } else if (err && err["Message"] == "success") {
                    this._onSaveRowData_Response(err["Message"]);
                }
            })
        );

    }

    setBatchSaveButtonStyle() {
        if (this.unsavedRows.length) {
            this.UiModder.domClass.remove(this.batchSaveButton, "w3-disabled secondaryBG");
            this.UiModder.domClass.add(this.batchSaveButton, "accentBG");
        } else {
            this.UiModder.domClass.add(this.batchSaveButton, "w3-disabled secondaryBG");
            this.UiModder.domClass.remove(this.batchSaveButton, "accentBG");
        }
    }

    _onSaveRowData_Response(response): void {
        this.StandbyStop();

        if (response == "success") {

            //for (let rowIndex of this.rowIndex_savingInProcess) {

            //    let rowWidgets = this.staticTable.getRowWidgets(rowIndex);
            //    let button: any = null;

            //    for (let i = 0; i < rowWidgets.length; i++) {

            //        if (rowWidgets[i]["nodeName"] && rowWidgets[i]["nodeName"] == "BUTTON") {
            //            button = rowWidgets[i];
            //        }
            //    }
            //    if (button != null) {
            //        button.disabled = true;
            //    }
            //}
            
            this.unsavedRows = [];
            //this.unsavedRows.splice(this.unsavedRows.indexOf(this.rowIndex_savingInProcess), 1);

            this.setBatchSaveButtonStyle();

            this.loadData(this.bookingId);

        } else { console.log("_onSaveRowData_Response: ", response); }
        this.rowIndex_savingInProcess = [];

    }

    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.widgetRegistry = [];
       
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        this.createTable();
    }
}

export default mdsWidget(ToDoListEditor);